// client/src/routes/app/tenants/$tenantId/index.tsx — SCR-TEN-002 tab „Profil" · TEN-004.
//
// The layout above has already fetched the tenant; `useTenant` here is the same query key, so
// react-query serves it from cache rather than issuing a second request. Reading it again beats
// threading it through an Outlet context: each tab states what it needs, and a tab opened by
// direct URL works the same as one reached by clicking.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { ProfileTab } from '@/features/tenants/ProfileTab';
import { useTenant } from '@/features/tenants/queries';

export const Route = createFileRoute('/app/tenants/$tenantId/')({
  component: ProfileTabScreen,
});

function ProfileTabScreen() {
  const { tenantId } = Route.useParams();
  const tenant = useTenant(tenantId);

  if (tenant.isPending) return <LoadingState rows={3} />;
  if (tenant.isError) return <ErrorState error={tenant.error} onRetry={() => void tenant.refetch()} />;

  return <ProfileTab tenant={tenant.data} />;
}
